// ═══════════════════════════════════════════════════
// App.tsx — The root of Proppulse.ai
// Providers, global error boundary, reduced motion
// ═══════════════════════════════════════════════════

import { RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MotionConfig } from 'framer-motion';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { Atmosphere } from '@/components/shared/Atmosphere';
import { router } from './router';

// ── React Query Config ───────────────────────────
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,        // 30s before data is considered stale
      gcTime: 5 * 60_000,       // 5min garbage collection
      retry: 2,                  // Retry failed requests twice
      refetchOnWindowFocus: true, // Refetch when user returns to tab
    },
    mutations: {
      retry: 1,
    },
  },
});

// ── Reduced Motion Detection ─────────────────────
const prefersReducedMotion =
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export default function App() {
  return (
    <ErrorBoundary level="app">
      <QueryClientProvider client={queryClient}>
        <MotionConfig reducedMotion={prefersReducedMotion ? 'always' : 'never'}>
          <Atmosphere />
          <RouterProvider router={router} />
        </MotionConfig>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

